import React from 'react';
import routes from 'src/routes';
import useLocationKey from 'src/hooks/useLocationKey';
import { AlertResultsProvider } from './AlertResultsProvider';
import { AlertResults } from './AlertResults';
import { FiltersContextProvider } from './AlertResultsFilters/FiltersContext';

export default () => {
  const locationKey = useLocationKey((location) => {
    if (location.pathname === routes.alertResults) {
      return location.key;
    }
  });

  return (
    <AlertResultsProvider key={locationKey}>
      <FiltersContextProvider>
        <AlertResults />
      </FiltersContextProvider>
    </AlertResultsProvider>
  );
};
